// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ProjectPersonnelClaimsReportMonthDetail  {
    _originalTypeClassName = "Loom.BO.ProjectPersonnelClaimsReportMonthDetail";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ProjectPersonnelClaimsReportMonthDetail.translate = translateService;
}
this.ProjectPersonnelClaimsEmployeeDetails = [];
this.Id = null;
this.Month = null;
this.MonthStr = null;
this.TotalPersonHours = null;
this.TotalPersonMonths = null;
this.PersonnelCosts_A1A2A3_actuals = null;
this.PersonnelCosts_A1A2A3_unit = null;
this.PersonnelCosts_A4_unit = null;
this.PersonnelCosts = null;
this.ActualWorkedDaysInMonth = null;
this.TotalDayEquivalents = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Month:any;
MonthStr:any;
TotalPersonHours:any;
TotalPersonMonths:any;
PersonnelCosts_A1A2A3_actuals:any;
PersonnelCosts_A1A2A3_unit:any;
PersonnelCosts_A4_unit:any;
PersonnelCosts:any;
ActualWorkedDaysInMonth:any;
TotalDayEquivalents:any;
ProjectCostsReport:any;
ProjectPersonnelClaimsEmployeeDetails:any;
static setProjectCostsReport = ($this, value) => {
var oldValue = $this.ProjectCostsReport;
$this.ProjectCostsReport = value;
if (value != null) {
if (oldValue != null) {
Domain.ProjectPersonnelClaimsReport.removeProjectCostsReportDetails(oldValue, $this);
}
Domain.ProjectPersonnelClaimsReport.addProjectCostsReportDetails(value, $this);
}
}
static setProjectPersonnelClaimsEmployeeDetails = ($this, items) => {
                if (items == null) items = [];
                if ($this.ProjectPersonnelClaimsEmployeeDetails == null) $this.ProjectPersonnelClaimsEmployeeDetails = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ProjectPersonnelClaimsEmployeeDetails.length > 0) {
                    Domain.ProjectPersonnelClaimsReportMonthDetail.removeProjectPersonnelClaimsEmployeeDetails($this, $this.ProjectPersonnelClaimsEmployeeDetails[0]);
                }

                Domain.ProjectPersonnelClaimsReportMonthDetail.addManyProjectPersonnelClaimsEmployeeDetails($this, copyItems);
            }
static addManyProjectPersonnelClaimsEmployeeDetails = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.ProjectPersonnelClaimsReportMonthDetail.addProjectPersonnelClaimsEmployeeDetails($this, items[i]);
                }
            }
static addProjectPersonnelClaimsEmployeeDetails = ($this, item) => {
                if ($this.ProjectPersonnelClaimsEmployeeDetails == null) $this.ProjectPersonnelClaimsEmployeeDetails = [];
                if (item == null || $this.ProjectPersonnelClaimsEmployeeDetails.indexOf(item) > -1) return;
                $this.ProjectPersonnelClaimsEmployeeDetails.push(item);
if (item.ProjectPersonnelClaimsReportMonthDetail != $this) {
Domain.ProjectPersonnelClaimsEmployeeDetail.setProjectPersonnelClaimsReportMonthDetail(item, $this);
}
}
static addRangeProjectPersonnelClaimsEmployeeDetails = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.ProjectPersonnelClaimsReportMonthDetail.addProjectPersonnelClaimsEmployeeDetails($this, item));
            }
static removeProjectPersonnelClaimsEmployeeDetails = ($this, item) => {
                if ($this == null || $this.ProjectPersonnelClaimsEmployeeDetails == null || $this.ProjectPersonnelClaimsEmployeeDetails.indexOf(item) === -1) return;
                var _index = $this.ProjectPersonnelClaimsEmployeeDetails.indexOf(item);
                $this.ProjectPersonnelClaimsEmployeeDetails.splice(_index, 1);
item.ProjectPersonnelClaimsReportMonthDetail = null;
}
static clearProjectPersonnelClaimsEmployeeDetails = ($this) => { $this.ProjectPersonnelClaimsEmployeeDetails = null; }

static GetMonthStr($this: any): any{return CLMS.Framework.DateTime.ToString($this?.Month, "MMM yyyy");
}
static GetPersonnelCosts($this: any): any{return Joove.Common.safeNumber($this?.PersonnelCosts_A1A2A3_actuals) + Joove.Common.safeNumber($this?.PersonnelCosts_A1A2A3_unit) + Joove.Common.safeNumber($this?.PersonnelCosts_A4_unit);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}